import React, { useState } from 'react';
import { Customer, QuestionnaireTemplate, Service, SystemConfig } from '@/types';
import { CustomerList } from './CustomerList';
import { CustomerEditor } from './CustomerEditor';
import { CustomerDetailPanel } from './CustomerDetailPanel';

interface CustomersTabProps {
  services?: Service[];
  questionnaires?: QuestionnaireTemplate[];
  canEdit: boolean;
  canRevokeCertificate?: boolean;
  canOverrideLockedPaperwork?: boolean;
  targetCustomerId: string | null;
  targetCustomerSearch: string | null;
  onClearTargetCustomer: () => void;
  onClearTargetCustomerSearch: () => void;
  systemConfig?: SystemConfig;
}

export const CustomersTab: React.FC<CustomersTabProps> = ({
  services = [],
  questionnaires = [],
  canEdit,
  canRevokeCertificate = false,
  canOverrideLockedPaperwork = false,
  targetCustomerId,
  targetCustomerSearch,
  onClearTargetCustomer,
  onClearTargetCustomerSearch,
  systemConfig
}) => {
  const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
  const [editingCustomer, setEditingCustomer] = useState<Customer | null>(null);

  const handleSelect = (customer: Customer) => {
    setSelectedCustomer(customer);
  };

  const handleClose = () => {
    setSelectedCustomer(null);
    onClearTargetCustomer();
  };

  return (
    <div className="animate-fade-in h-[calc(100vh-200px)] flex flex-col">
      {editingCustomer && (
        <CustomerEditor
          customer={editingCustomer}
          onSaved={(updated) => {
            setSelectedCustomer(updated);
            setEditingCustomer(null);
          }}
          onClose={() => setEditingCustomer(null)}
        />
      )}

      {selectedCustomer ? (
        <CustomerDetailPanel
          customer={selectedCustomer}
          services={services}
          questionnaires={questionnaires}
          systemConfig={systemConfig}
          canEdit={canEdit}
          canRevokeCertificate={canRevokeCertificate}
          canOverrideLockedPaperwork={canOverrideLockedPaperwork}
          onEdit={() =>
            setEditingCustomer({
              ...selectedCustomer
            })
          }
          onClose={handleClose}
        />
      ) : (
        <CustomerList
          targetCustomerId={targetCustomerId}
          targetSearch={targetCustomerSearch}
          onSelect={handleSelect}
          onClearTarget={onClearTargetCustomer}
          onClearTargetSearch={onClearTargetCustomerSearch}
        />
      )}
    </div>
  );
};
